import { useEffect, useRef } from 'react'

export function useEffectAfterMount(
  effect: React.EffectCallback,
  deps?: React.DependencyList | undefined
) {
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current) {
      effect()
    }

    isMounted.current = true
  }, deps)
}
